import { Icon, IconButton, useToast } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { FaBookmark, FaCheck, FaCheckCircle, FaHeart, FaRegStar, FaStar } from "react-icons/fa";
import { useAPI } from "@/contexts/APIContext";
import { useUserData } from "@/contexts/UserDataContext";
import ModalAuth from "./ModalAuth";

export default function FavoriteProfilesButton({ id }) {
  const { currentUser, userData } = useUserData();
  const [favorited, setFavorited] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    setFavorited(userData?.favoriteProfiles?.includes(id));
  }, [userData]);

  const toast = useToast();
  const api = useAPI();

  const onFavoriteAction = async (e) => {
    e.stopPropagation();
    if (!currentUser) {
      // Show registration modal
      setShowAuthModal(true);
      return;
    }
    const operation = favorited ? "remove" : "add";
    setFavorited((i) => !i);
    await api.post("users/data", true, { favoriteProfiles: { operation, id } });
    toast({
      title: operation === "add" ? "Added to favorites" : "Removed from favorites",
      description:
        operation === "add" ? "You can view your favorites in your account dashboard." : "",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  return (
    <>
      <ModalAuth
        open={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onComplete={() => window.location.reload()}
        header="To save profiles to your favorites, create a free account with us."
      />
      <AnimatePresence mode="wait">
        {favorited ? (
          <motion.div
            key={0}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            transition={{ duration: 0.1 }}
          >
            <IconButton
              variant="unstyled"
              size="lg"
              icon={<Icon w={5} h={5} as={FaStar} />}
              onClick={(e) => onFavoriteAction(e)}
            />
          </motion.div>
        ) : (
          <motion.div
            key={1}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            transition={{ duration: 0.1 }}
          >
            <IconButton
              variant="unstyled"
              size="lg"
              icon={<Icon w={5} h={5} as={FaRegStar} />}
              onClick={(e) => onFavoriteAction(e)}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
